module.exports = ".block-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 15px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/shot/shot-block-settings/shot-block-settings.component.less
// module id = ./src/app/projects/shot/shot-block-settings/shot-block-settings.component.less
// module chunks = main